"use client";

import { TwoColumnsPage } from "templates/TwoColumnPage";

export default function CustomerServiceClient({ serializedPage }) {
    return (
        <>
            <div hidden aria-hidden="true" data-testid="customerServiceSlug" />
            <TwoColumnsPage serializedPage={serializedPage} />
        </>
    );
}
